<template>
    <v-container>
        <v-row density="compact">
            <v-col cols="12" class="text-center my-3">
                <h2>Verifique se a ficha médica está atualizada e autorize a participação do evento ao final</h2>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        {{ participant?.name }}
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <FichaMedica
                                         :user="user"
                                         :legalPerson="participant"
                                         :admin="groupAdmin"
                                         @updated="medicalRecordUpdated" />
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6" offset="3" v-if="validMedicalRecord">
                <v-card>
                    <v-card-title>
                        Autorização para o evento
                    </v-card-title>
                    <v-card-text>
                        <p class="mb-3">Eu, <strong>{{ user?.legal_person?.name?.toUpperCase() }}</strong>,
                            nesta data de <strong>{{ $moment.parseZone().format('DD/MM/YYYY') }}</strong>
                            às <strong>{{ $moment.parseZone().format("HH:mm:ss") }}</strong> sob o IP
                            <strong>{{ clientIP }}</strong>,
                            como responsável, autorizo <strong>{{ participant?.name?.toUpperCase() }}</strong>,
                            membro do Movimento Escoteiro, a participar da seguinte atividade externa:
                            <strong>{{ event?.name }}</strong>
                            , localizada em
                            <strong>{{ event?.address_name }}</strong>, <strong>{{ event?.address }}</strong>,
                            realizada pelo
                            <strong>{{ event?.group?.name }}</strong>
                            em <strong>{{ $moment.parseZone(event?.start_date).format('DD/MM/YYYY') }}</strong>.
                        </p>
                        <p class="mb-3">Saída:
                            <strong v-if="!!event?.exit_point_date">
                                {{ $moment.parseZone(event?.exit_point_date).format('DD/MM/YYYY') }}
                            </strong>
                            <strong v-if="!!event?.exit_point_time">
                                às {{ event?.exit_point_time }}
                            </strong>
                            <strong v-if="!!event?.exit_point_address_name">
                                - {{ event?.exit_point_address_name }}
                            </strong>
                            <strong v-if="!!event?.exit_point_address">
                                , {{ event?.exit_point_address }}
                            </strong>
                        </p>
                        <p class="mb-3">Chegada:
                            <strong v-if="!!event?.arrival_point_date">
                                {{ $moment.parseZone(event?.arrival_point_date).format('DD/MM/YYYY') }}
                            </strong>
                            <strong v-if="!!event?.arrival_point_time">
                                às {{ event?.arrival_point_time }}
                            </strong>
                            <strong v-if="!!event?.arrival_point_address_name">
                                - {{ event?.arrival_point_address_name }}
                            </strong>
                            <strong v-if="!!event?.arrival_point_address">
                                , {{ event?.arrival_point_address }}
                            </strong>
                        </p>
                        <p class="mb-3">Tendo total ciência de que o
                            <strong>{{ event?.group?.name }}</strong>, na figura de
                            <strong>{{ event?.coordinator?.name?.toUpperCase() }}</strong>, é
                            responsável {{ participant?.gender === 'Masculino' ? 'pelo associado' : 'pela associada' }}
                            <strong>{{ participant?.name?.toUpperCase() }} </strong>
                            apenas durante a realização da referida atividade, ficando isento de
                            responsabilidades pelo deslocamento
                            {{ participant?.gender === 'Masculino' ? 'do associado' : 'da associada' }}
                            <strong>{{ participant?.name?.toUpperCase() }}</strong> de sua residência até o local de saída
                            da
                            atividade, como seu retorno do local de chegada da atividade até sua residência.
                        </p>
                        <v-checkbox label="CIENTE" v-model="authorizeChecked"></v-checkbox>
                    </v-card-text>
                    <v-card-actions v-if="authorizeChecked">
                        <v-btn variant="text"
                               @click="authorizeEvent()">
                            <v-icon>mdi-check</v-icon>
                            AUTORIZAR A PARTICIPAÇÃO
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import FichaMedica from './FichaMedica.vue';
import api from '@/services'

export default {
    components: {
        FichaMedica,
    },
    props: {
        user: Object,
        participant: Object,
        event: Object,
    },
    emits: ['authorized'],
    data() {
        return {
            requestingApi: false,
            clientIP: null,
            authorizeChecked: false
        }
    },
    created() {
        const vm = this;

        vm.getClientIP();
    },
    computed: {
        groupAdmin() {
            const vm = this;

            return vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
        },
        validMedicalRecord() {
            const vm = this;
            const isAuthorized = !!vm.participant?.medical_record?.authorized;
            const updatedThisWeek = vm.$moment.parseZone().startOf("day").isBefore(vm.$moment.parseZone(vm.participant?.medical_record?.updated_at).startOf('day').add(8, 'd'));

            return isAuthorized && updatedThisWeek;
        },
    },
    methods: {
        medicalRecordUpdated(newMedicalRecord) {
            const vm = this;

            vm.participant.medical_record = newMedicalRecord;
        },
        getClientIP() {
            const vm = this;

            vm.requestingApi = true;
            return new Promise((resolve, reject) => {
                api.eventAuthorization
                    .getClientIP()
                    .then((result) => {
                        vm.clientIP = result;
                    })
                    .catch((err) => {
                        if (err.message) {
                            vm.$notify({
                                type: "warn",
                                text: err.message,
                            });
                        }
                    })
                    .finally(() => {
                        vm.requestingApi = false;
                    });
            });
        },
        authorizeEvent() {
            const vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.eventAuthorization
                        .authorize({
                            event_id: vm.event.id,
                            invitee_id: vm.participant.id
                        }).then((result) => {
                            vm.$notify({
                                type: "success",
                                text: "Autorização Concedida!",
                            });
                            vm.$emit('authorized', result);
                        }).catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            } else {
                vm.$notify({
                    type: "warn",
                    text: 'Aguarde um instante e tente novamente!',
                });
            }
        }
    }
}
</script>